import { useEffect, useState } from "react";
import "./User_SectionOne.scss";
import { useParams } from "react-router-dom";
import { getUser } from "../../../services/user/user";
import { getCookie } from "../../../helper/cookie";
import { TiStarFullOutline } from "react-icons/ti";
import Tab_User from "../../../components/Tabs_User";

function User_SectionOne() {
  const [user, setUser] = useState([]);
  const params = useParams();
  const token = getCookie("token");

  useEffect(() => {
    const fetchApi = async () => {
      const contentUser = await getUser(params.name, token);
      setUser(contentUser);
    };
    fetchApi();
  }, []);

  return (
    <>
      <div className="user-sectionOne">
        <div className="container">
          {user.length > 0 && (
            <div className="user-sectionOne-wrapper">
              {user.map((item) => (
                <div key={item.id} className="user-sectionOne-info">
                  <div className="info-common">
                    <div className="info-common-img">
                      <img src={item.avatar} alt="Avatar User" />
                    </div>

                    <div className="info-common-details">
                      <div className="info-name">{item.username}</div>
                      <div className="info-icon">
                        <TiStarFullOutline />
                        <TiStarFullOutline />
                        <TiStarFullOutline />
                        <TiStarFullOutline />
                        <TiStarFullOutline />
                      </div>
                      <div className="info-status">{item.status}</div>
                    </div>
                  </div>

                  <div className="info-fl">
                    <div className="info-fl-fler">
                      <b>{item.follower}</b> người theo dõi
                    </div>
                    <div className="info-fl-fling">
                      <b> {item.following}</b> đang theo dõi
                    </div>
                  </div>

                  <div className="info-shop">
                    <b>Cửa hàng</b>
                  </div>

                  <Tab_User />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default User_SectionOne;
